var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"headline-wrapper"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))])])
}
var staticRenderFns = []

export { render, staticRenderFns }